/** "2026-05-29" → "Fri, 29 May 2026". Falls back to the raw value if it can't be parsed. */
export function formatApiDate(dt?: string): string {
  if (!dt) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dt);
  if (!match) return dt;
  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (Number.isNaN(date.getTime())) return dt;
  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** "00:30:00" → "12:30 AM". Falls back to the raw value if it can't be parsed. */
export function formatApiTime(tm?: string): string {
  if (!tm) return "";
  const match = /^(\d{1,2}):(\d{2})/.exec(tm);
  if (!match) return tm;
  const hours = Number(match[1]);
  const minutes = match[2];
  if (Number.isNaN(hours)) return tm;
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${hour12}:${minutes} ${period}`;
}
